import type { JiraIssue } from '../api/JiraApi';

export function buildBatchedPrompt(
  issues: JiraIssue[],
  extraInstructions: string,
): string {
  const issueList = issues
    .map(i => `- ${i.key}: ${i.summary}   (${i.url})`)
    .join('\n');

  const lines = [
    'Resolve the following Jira issues:',
    issueList,
    '',
    'For each issue:',
    '1. Use the getJiraIssue tool to fetch its full',
    '   description, acceptance criteria, and any linked PRs.',
    '2. Implement the required changes. You may land all changes on this one branch',
    '   (decide per issue whether to split into multiple commits or a single combined one).',
    // '3. Before finishing, transition each issue to "In Review" with a link back to the PR',
    // '   you open.',
  ];

  if (extraInstructions.trim()) {
    lines.push('', extraInstructions.trim());
  }

  return lines.join('\n');
}

export function branchSuffix(issues: JiraIssue[]): string {
  if (issues.length === 1) {
    return `jira-${issues[0].key.toLowerCase()}`;
  }
  return `jira-batch`;
}
